export const createPayload = (data) => ({
  ts: Date.now(),
  data
})



// WEBPACK FOOTER //
// ./src/store/utils/common.js